import React, { useEffect, useState } from "react";
import backicon from "./../../../../../../Assets/icons/backIcon.svg";
// import "./index.scss";
import { useLocation, useNavigate } from "react-router-dom";
import DynamicForm from "../../../../../customformComponent/customForm/DynamicForm";
import axiosInstance from "../../../../../services/api/API";
import Loader from "../../../../../customComponents/CustomLoader";
import ROUTES_NAVIGATION from "../../../../../../routes/routes";
import { showCustomAlert } from "../../../../../customComponents/CustomSweetAlert";
import { showErrorAlert } from "../../../../../customComponents/CustomSweetAlert/errorsweetalert";
import validations from "../../../../../../helpers/validations";
import { buttonStyle, isFormValid } from "../../../../../../helpers/common";

const EditProductFinancier = () => {
  const token = localStorage.getItem("authToken");
  const [formData, setFormData] = useState({});
  const location = useLocation();
  const [validationErrors, setValidationErrors] = useState({});
  const { data } = location.state || {};

  const [loading, setLoading] = useState(false);
  const [editFinancier, setEditFinancier] = useState([]);
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);

  const [userTypedd, setUserTypedd] = useState([]);
  const userType = localStorage.getItem("UserType");
  const businessPartnerId = localStorage.getItem("business_partner_id");

  useEffect(() => {
    userTypedropdown();
  }, []);

  const userTypedropdown = async () => {
    try {
      const response = await axiosInstance.get("/bp-onboard/bplist", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = response.data.data.data;
      const userTypeOptions = data.map((user) => ({
        value: user.onboard_id,
        label: user.bp_name,
      }));
      setUserTypedd(userTypeOptions);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchFinancierEdit();
  }, []);

  // useEffect(() => {
  //     if (data) {
  //         console.log("financierData", data);
  //         const transformedData = {
  //             financer_name: data.financer_name,
  //             financer_desc: data.financer_desc,
  //             status: { label: data.status, value: data.status },
  //         };
  //         setFormData(transformedData);
  //         console.log(transformedData, "transformedData");
  //     }
  // }, [data]);

  const navigate = useNavigate();

  const fetchFinancierEdit = async () => {
    setLoading(true);
    try {
      const response = await axiosInstance.get(
        `/financer/edit/${data.financer_id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const fetchedData = response.data.data;
      const transformedData = {
        business_partner_id: fetchedData.business_partner_id,
        financer_name: fetchedData.financer_name,
        financer_desc: fetchedData.financer_desc,
        status: fetchedData.status,
      };
      setFormData(transformedData);
      setEditFinancier(fetchedData);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const handleFormSubmit = async (formData) => {
    try {
      setIsFormSubmitted(true);
      console.log("Form Data Financier:", formData, data);

      // Validate the form data if needed

      // Show confirmation alert before proceeding with the update
      showCustomAlert({
        title: "Confirm Update",
        text: "Are you sure you want to update this Financier record?",
        confirmButtonText: "Yes",
        cancelButtonText: "Cancel",
        icon: "warning",
        callback: async () => {
          setLoading(true);
          const payload = {
            financer_name: formData.financer_name,
            financer_desc: formData.financer_desc,
            status: formData.status === true ? 1 : 0,
          };

          if (userType === "superadmin") {
            payload.business_partner_id = formData.business_partner_id;
          } else {
            payload.business_partner_id = businessPartnerId;
          }

          try {
            // Send the update request
            const response = await axiosInstance.patch(
              `/financer/update/${data.financer_id}`,
              payload,
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${token}`,
                },
              },
            );

            console.log("Update successful!", response.data);

            // Show success alert after successful update
            showCustomAlert({
              title: "Success",
              text: "Financier updated successfully.",
              confirmButtonText: "OK",
              icon: "success",
              callback: () => {
                navigate(ROUTES_NAVIGATION.PRODUCTFINANCIERLIST); // Navigate after user clicks OK
              },
            });
          } catch (error) {
            console.error("Error updating product financier:", error);

            // Extract error message from the response
            const errorMessage =
              error.response?.data?.message ||
              "An error occurred while updating the financier.";

            // Show error alert with the error message
            showErrorAlert({
              title: "Something went wrong",
              text: errorMessage,
              callback: () => {
                console.log("Error alert confirmed");
              },
            });
          } finally {
            setLoading(false);
          }
        },
      });
    } catch (error) {
      console.error("Unexpected error:", error);
      showErrorAlert({
        title: "Unexpected Error",
        text: "An unexpected error occurred. Please try again.",
        callback: () => {
          console.log("Unexpected error alert confirmed");
        },
      });
    }
  };

  const ProductFinancierInputs = [
    ...(userType === "superadmin"
      ? [
          {
            name: "business_partner_id",
            label: "Business Partner",
            type: "dropdown",
            required: true,
            options: userTypedd,
            gridClass: "col-lg-4",
            validation: validations.businessPartnerId({ required: true }),
          },
        ]
      : []),
    {
      name: "financer_name",
      label: "Name",
      type: "text",
      validation: validations.financierName({ required: true }),
      required: true,
      gridClass: "col-lg-4",
      disabled: true,
    },
    {
      name: "financer_desc",
      label: "Description",
      type: "text",
      required: true,
      validation: validations.description({ required: true }),
      gridClass: "col-lg-4",
    },
    {
      name: "status",
      label: "Status",
      type: "toggle",
      gridClass: "col-lg-1",
    },
  ];

  return (
    <div>
      {loading ? (
        <Loader />
      ) : (
        <>
          <div className="backbutton mt-2 mb-2">
            <img
              style={{ cursor: "pointer" }}
              onClick={() => navigate(-1)}
              src={backicon}
              alt="back"
            />
            <span className="backbtntitle">Edit Product Financier</span>
          </div>
          <div className="form-container">
            <span className="cust-det-title mt-2 mb-2">
              Please Edit Product Financier Details
            </span>
            <DynamicForm
              validateOnMount
              formConfig={ProductFinancierInputs}
              formData={formData}
              setFormData={setFormData}
              onSubmit={handleFormSubmit}
              validationErrors={validationErrors}
              setValidationErrors={setValidationErrors}
            />
          </div>
          <div className="btncontainer mt-3">
            <button
              className="submit-btn"
              disabled={
                !isFormValid(
                  ProductFinancierInputs,
                  formData,
                  validationErrors,
                ) || loading
              }
              style={buttonStyle(
                ProductFinancierInputs,
                formData,
                validationErrors,
                loading,
              )}
              onClick={() => handleFormSubmit(formData)}
            >
              Submit
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default EditProductFinancier;
